import { Box, Flex, FormLabel, Heading } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { closeCreateChapterModel } from "../../../../modules/admin-modules/models/Actions";
import {
  createCourseRequest,
  editCourseRequest,
} from "../../../../modules/superadmin-modules/courses/Actions";
import { getAllSubjectsRequest } from "../../../../modules/superadmin-modules/subjects/Actions";
import { getAllTeachersRequest } from "../../../../modules/superadmin-modules/teachers/Actions";

const AddCourse = ({ isAdd, data, setSelectedData }) => {
  const [selected, setSelected] = useState("");
  const openChapter = useSelector((state) => state.model.isOpen11);
  const subjects = useSelector((state) => state.superadminSubjects.subjects);
  const isLoading = useSelector((state) => state.chapters.isLoading);
  const teachers = useSelector((state) => state.superadminTeachers.teachers);

  const dispatch = useDispatch();
  useEffect(() => {}, []);

  const subjectsOptions = subjects?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const defaultSubjects = {
    label: data?.subject?.name,
    value: data?.subject?.id,
  };
  const teachersOptions = teachers?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const defaultTeachers = {
    label: data?.teacher?.name,
    value: data?.teacher?.id,
  };

  useEffect(() => {
    if (openChapter) {
      dispatch(getAllSubjectsRequest());
      dispatch(getAllTeachersRequest());
    }
  }, [openChapter]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    getValues,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة الفصل" : "تعديل  الفصل"}
      </Heading>
    </Box>
  );
  const onSubmit = async (values) => {
    console.log(values);
    const action = () => {
      dispatch(closeCreateChapterModel());
      setSelectedData({});
      reset();
    };

    if (isAdd) {
      if (values.subject_id) {
        await dispatch(createCourseRequest(values, action));
      } else {
        toast.error("اختر المادة");
      }
    } else {
      const totel = { ...data, ...values };
      let formData = await new FormData();
      formData.append("_method", "PUT");

      for (let key in totel) {
        formData.append(key, totel[key]);
      }
      dispatch(
        editCourseRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };
  const closeFunc = () => {
    dispatch(closeCreateChapterModel());
    setSelectedData({});
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openChapter}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="45%">
            <MainInput
              label="اسم الدورة التعليمية"
              defaultValues={data?.name}
              error={errors?.name?.message}
              placeholder="ادخل اسم الدورة التعليمية"
              register={register}
              name="name"
            />
          </Box>

          <Box w="45%">
            <Box w="100%">
              <FormLabel>المادة : </FormLabel>
              <Select
                options={subjectsOptions}
                onChange={(data) => setValue("subject_id", data.value)}
                styles={colourStyles}
                placeholder="المادة"
                defaultValue={defaultSubjects}
              />
            </Box>
          </Box>
          <Box w="45%">
            <Box w="100%">
              <FormLabel>المعلمين : </FormLabel>
              <Select
                options={teachersOptions}
                onChange={(data) => setValue("teacher_id", data.value)}
                styles={colourStyles}
                placeholder="المعلمين"
                defaultValue={defaultTeachers}
              />
            </Box>
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddCourse;
